import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  Goals = 'Goals',
}

export const queryKeys = {
  goals: (clientId: string) => [QueryFeature.Profile, QueryKey.Goals, clientId],
};
